
define(
	'Code25.CaterpartsGlobal.Utils'
	, [
		"Handlebars", "Utils", "Tools"
	]
	, function (
		Handlebars, Utils, Tools
	) {
		'use strict';



		return {
			mount: function mount(container) {

				var Environment = container.getComponent('Environment');
				if (!Environment.isPageGenerator()) {
					Object.defineProperty && Object.defineProperty(document, 'title', {
						get: function () {

							return this._title;
						},
						set: function (val) {
							if(val=="NOT ALLOWED"){
								return;
							}
							this._title = val + " | Caterparts";
							document.getElementsByTagName("title")[0].innerText = this._title;
						}
					});
				}

				function parseCurrency(currency) {

					var regex = /([+-]?[0-9|^.|^,]+)[\.|,]([0-9]+)$/igm
					var result = regex.exec(currency);
					var floatResult = result ? result[1].replace(/[.,]/g, "") + "." + result[2] : currency.replace(/[^0-9-+]/g, "");
					if (floatResult) {
						return parseFloat(floatResult);
					}
					return 0;
				}

				Handlebars.registerHelper('debug', function (line) {

					console.log(line);
					return "";

				});

				Handlebars.registerHelper('categories', function (categories) {

					var count = 0;
					for (var i = 0; i < categories.length; i++) {
						if (categories[i].letter) {
							count++;
						}
						count++;
					}

					var column = Math.ceil(count / 7);
					if (column < 4) {
						column = 4;
					}
					var pos = 0;
					var found = 0;
					for (var i = 0; i < categories.length; i++) {
						if (categories[i].letter) {
							if (pos == column - 1) {
								pos = 0;
								found++;
							}
							pos++;
						}
						count++;
						pos++;
						if (pos == column && i < categories.length - 1) {
							pos = 0;
							found++;
						}
					}
					if (found >= 7) {
						column++;
					}

					var body = "";
					body += "<ul class=\"header-menu-level-container\">";
					body += "<li>";
					body += "<ul class=\"header-menu-level2\"><li><ul>";
					pos = 0;
					for (var i = 0; i < categories.length; i++) {

						if (categories[i].letter) {
							if (pos == column - 1) {
								pos = 0;
								body += "</ul></li><li><ul>";
							}
							body += "<li class=\"menu-letter\">" + categories[i].letter + "</li>";
							pos++;
						}
						body += "<li>";
						body += "<a class=\"header-menu-level3-anchor\"";
						if (categories[i].href) {
							body += " href=\"" + categories[i].href + "\"";
						}
						if (categories[i].data && categories[i].data.touchpoint) {
							body += " data-touchpoint=\"" + categories[i].data.touchpoint + "\"";
						}
						if (categories[i].data && categories[i].data.hashtag) {
							body += " data-hashtag=\"" + categories[i].data.hashtag + "\"";
						}
						body += ">" + categories[i].text + "</a>";
						body += "</li>";
						pos++;
						if (pos == column && i < categories.length - 1) {
							pos = 0;
							body += "</ul></li><li><ul>";
						}
					}
					body += "</ul></li></ul>";
					body += "</li>";
					body += "</ul>";

					return body;

				});

				// Helper 'ifAny' works like if (v2.indexOf(v1)>-1) {} else {}
				Handlebars.registerHelper('ifAny', function (v1, v2, options) {
					if (v2) {
						v2 = v2.split(",");
					} else {
						v2 = [];
					}
					if (v1 && v2.indexOf(v1) > -1) {
						return options.fn(this);
					}
					return options.inverse(this);
				});

				Handlebars.registerHelper('unlessAny', function (v1, v2, options) {
					if (v2) {
						v2 = v2.split(",");
					} else {
						v2 = [];
					}
					if (v1 && v2.indexOf(v1) > -1) {
						return options.inverse(this);
					}
					return options.fn(this);

				});

				Handlebars.registerHelper('findsku', function (sku, line) {
					if (!sku && line) {
						var model = line.model;
						if (model) {
							var options = model.get("options"), cartOptionId, value;
							for (var i = 0; i < options.length; i++) {
								cartOptionId = options.models[i].get("cartOptionId");

								if (cartOptionId == "custcolcustcol_trans_body_item_code_2") {
									value = options.models[i].get("value");
									if (value.internalid) {
										sku = value.internalid;//+" ("+Utils.translate("Part Details not Found")+")";
									}
								}
							}

						}
					}

					return sku || Utils.translate("Part Details not Found");
				});
				Handlebars.registerHelper('removeW', function (text) {
					if (text) {
						text = text.split(" (W)").join("");
						text = Utils.translate(text);
					}

					return text;
				});


				Handlebars.registerHelper('calcDiscount', function (price, oldprice) {

					oldprice = parseCurrency(oldprice);
					price = parseCurrency(price);

					if (oldprice > 0 && price > 0 && oldprice > price) {
						return "&nbsp;&nbsp;<span class=\"discount-off\">" + (Math.round(200 * (1 - (price / oldprice))) / 2) + "% " + Utils.translate("Off") + "</span>";
					}
					return "";
				});

				Handlebars.registerHelper('cleanManu', function (value) {
					return Tools.cleanManu(value);
				});
				Handlebars.registerHelper('oemSubList', function (item, value) {

					var custitem_c25_hideoem = item && item.get("custitem_c25_hideoem");
					var sku = (item && item.get("_sku")) || "";

					if (value && !custitem_c25_hideoem) {
						var data;
						try {
							data = JSON.parse(value);
						} catch (err) {
							console.log("bad oem list", value);
						}
						if (data) {

							try {

								var preferred = "";
								if (data.preferred) {
									preferred = "<span class=\"facets-item-cell-list-sku\" style=\"white-space:inherit;\">Manufacturer Part Number</span>: " + data["preferred"].oem;
								}

								if (preferred) { //!Tools.isLive() && 
									return preferred;
								}

							} catch (err) {
								console.log(err);
							}
						}
					}
					return "<span class=\"facets-item-cell-list-sku\">Part Number</span>: " + sku;
				});
				Handlebars.registerHelper('oemList', function (item, value) {

					var custitem_c25_hideoem = item && item.get("custitem_c25_hideoem");
					var pricinggroup = Tools.cleanManu(item && item.get("pricinggroup"));

					if (value && !custitem_c25_hideoem) {
						var data;
						try {
							data = JSON.parse(value);
						} catch (err) {
							console.log("bad oem list", value);
						}
						if (data) {

							try {
								var custcol_c25_oemcode = this.model.get("custcol_c25_oemcode");

								var models = [];
								for (var i in data) {
									models.push(i);
								}
								models.sort(function (A, B) {
									if (A == pricinggroup) {
										A = "";
									}
									if (B == pricinggroup) {
										B = "";
									}
									return A.localeCompare(B);
								});

								var body = "", preferred = "", names;
								for (var i = 0; i < models.length; i++) {
									if (models[i] != "preferred") {
										// if (i > 0) {
										// 	body += "<br />";
										// }
										if (models[i] != pricinggroup) {
											body += "<p class=\"pdp-label\">" + models[i] + "</p>";
										}
										names = data[models[i]];
										names.sort(function (A, B) {
											return A.localeCompare(B);
										});
										body += "<div class=\"info-columns-md\">";
										for (var j = 0; j < names.length; j++) {
											if (j > 0) {
												body += "<br />";
											}
											body += names[j];
											if (custcol_c25_oemcode && names[j] == custcol_c25_oemcode) {
												body += " <i class=\"facets-match-icon\"></i>";
											}

										}
										body += "</div>";
									} else {

										preferred = "<p class=\"pdp-label\">Manufacturer Part Number</p><p class=\"pdp-value\" itemprop=\"sku\"> " + data[models[i]].oem + " </p>";
									}
								}


								if (body) {
									body = "<div class=\"product-oem-container\"><p class=\"pdp-label\">" + Utils.translate((preferred ? "Alternative/Superseded " : "Manufacturer ") + "Part Numbers") + "</p>" + body + "</div>";
								}
								if (!Tools.isLive()) {
									return "<div class=\"product-oem-list\">" + (preferred || body) + "</div>";
								} else if (preferred) {
									return "<div class=\"product-oem-list\">" + (preferred) + "</div>";
								}


							} catch (err) {
								console.log(err);
							}
						}
					}
					return "";
				});
				Handlebars.registerHelper('cleanHTML', function (value) {

					if (value) {
						return Tools.cleanHtml(value);
					}
					return "";
				});

				Handlebars.registerHelper('replacementLink', function (value) {

					if (value) {
						var data = {};
						try {
							data = JSON.parse(value);
						} catch (err) {
							console.log("bad item link", value);
						}
						if (data.urlcomponent) {
							return "<div class='alternative-item'><p><i class=\"info\"></i>&nbsp;<b>" + Utils.translate("This item is no longer available. Please use... ") + "</b> <a href='/" + data.urlcomponent + "'><i class=\"link\"></i>" + Utils.translate(" $(0)", data.storedisplayname) + "</a></p></div>";
						}
					}
					return "";
				});
				Handlebars.registerHelper('smallReplacementLink', function (value, message) {

					if (value) {
						var data = {};
						try {
							data = JSON.parse(value);
						} catch (err) {
							console.log("bad item link", value);
						}
						if (data.urlcomponent) {
							if (message && typeof message == "string") {
								return "<div class='alternative-item-right'><a href='/" + data.urlcomponent + "'><i class=\"link\"></i>" + Utils.translate(message) + " " + Utils.translate(" $(0)", data.storedisplayname) + "</a></div>";
							} else {
								return "<div class='alternative-item-right'><a href='/" + data.urlcomponent + "'><i class=\"link\"></i>" + Utils.translate(" $(0)", data.storedisplayname) + "</i></a></div>";
							}
						}
					}
					return "";
				});

				if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
					if (require) {

						var WizardStep = require("Wizard.Step");
						if (WizardStep) {
							WizardStep.prototype.showError = function () {
								try {
									if (this.error) {
										console.log("Checkout Error:", this.error);
										$("#pleaseWaitDialog").modal("hide");
										var msg = this.error.errorMessage;
										var code = this.error.errorCode;
										var statusText = this.error.statusText;
										if (statusText == "Gateway Timeout") {
											console.log("The connection to the server timed out. If this was for a large order, don't worry about it, the order still went through.", statusText);
											console.log("Error Code:", statusText);
										} else if (code == "ERR_WS_ERROR") {
											if (msg.indexOf("overdue") > -1) {
												Tools.showPayInvoicesInModal(container, Utils.translate("Unable to Pay by Invoice"), msg);
											} else {
												Tools.showErrorInModal(container, Utils.translate("Unable to Continue"), msg);
											}
										} else if (code == "ERR_WS_UNHANDLED_ERROR") {
											// if (msg && msg.indexOf("An error has occurred") > -1) {
											// 	console.log("Error Message:", msg);
											// 	console.log("Error Code:", code);
											// } else {
											if (msg.indexOf("Please") == -1 && msg.indexOf("incomplete") == -1 && msg.indexOf("empty") == -1) {
												msg = "We were unable to process this payment.<br /><br /><ol><li>Check the payment and address details have been entered correctly.</li><li>Check the account has sufficient funds.</li><li>Try a different card.</li><li>Contact us for assistance.</li></ol>";
											}
											Tools.showErrorInModal(container, Utils.translate("Unable to Continue"), msg);
											// }
										} else {
											console.log("Unknown Code:", code);
										}

										this.error = null;
									}
								} catch (e) {
									console.log(e);
								}
							}
						}
					}
				}

			}
		};
	});
